/* eslint-disable import/no-unresolved */
import { useLocation } from '@reach/router';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import styled from 'styled-components';

import { HeaderLogo, Link } from '@powdr/components';
import * as DemoComponents from '@powdr/components/demos';
import { DemoColorProfileToggle, DemoSeasonToggle, DemoPageJump } from '@powdr/components/demos';
import { ColorProfiles, Components, ThemeProps as Prop } from '@powdr/constants';
import { deslugify, componentColor } from '@powdr/utils';
import { useStaticData } from '@powdr/web/src/hooks';

const CPNT = Components.HEADER;

const DemoContainer = styled.div`
  ${({ offset }) => `margin: ${offset + 30}px 15px 30px 15px;`};
`;

const DemoHeader = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
`;

const MainHeaderContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  height: 100px;
`;

const NavigationContainer = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const NavItem = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  ${({ theme }) => theme.fonts.PRI_BDY_HVY};
  font-size: ${({ theme }) => theme.FontSize.REG30};
  text-align: center;
  line-height: 1em;
  overflow: hidden;
  padding: 0 5px;
  text-transform: uppercase;
  transition: 0.25s;

  ${({ active }) => ((active) ? `
    background-color: ${componentColor(Prop.NAV_ITEM_BG_ACTIVE, CPNT, Prop.CONTENT)};
    color: ${componentColor(Prop.NAV_ITEM_TXT_ACTIVE, CPNT, Prop.CONTENT)};
  ` : `
    background-color: ${componentColor(Prop.NAV_BG, CPNT, Prop.CONTENT)};
    color: ${componentColor(Prop.NAV_ITEM_TXT_SOLID, CPNT, Prop.CONTENT)};
  `)}

  &:hover {
    color: ${() => componentColor(Prop.NAV_ITEM_TXT_ACTIVE, CPNT, Prop.CONTENT)};
    background-color: ${() => componentColor(Prop.NAV_ITEM_BG_ACTIVE, CPNT, Prop.BACKGROUND)};
  }
`;

export const Demos = ({ data }) => {
  const DemoComponent = DemoComponents?.[`${data.type}`];
  const { pathname } = useLocation();
  const { headerConfig } = useStaticData();
  const headerRef = useRef(null);
  const [activeColorProfile, setActiveColorProfile] = useState(ColorProfiles.BASE);

  return (
    <DemoContainer offset={headerRef?.current?.clientHeight}>
      <DemoHeader ref={headerRef}>
        <MainHeaderContainer>
          <HeaderLogo isFromDemo />
          <NavigationContainer>
            {Object.values(data.demoTaxonomy).map((item) => (
              <NavItem
                key={item.route}
                active={pathname === `/demo/${item.route}`}
                href={`/demo/${item.route}`}
              >
                {deslugify(item.route)}
              </NavItem>
            ))}
          </NavigationContainer>
        </MainHeaderContainer>
        {headerConfig.isSeasonalityEnabled && <DemoSeasonToggle />}
        {(data.type !== 'ContentBlocksDemo') && <DemoColorProfileToggle onSelectColorProfile={setActiveColorProfile} />}
        <DemoPageJump />
      </DemoHeader>
      <DemoComponent colorProfile={activeColorProfile} />
    </DemoContainer>
  );
};

Demos.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

Demos.defaultProps = {

};
